webpackJsonp([1],{

/***/ "./common.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../node_modules/jquery/dist/jquery.slim.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_src_dropdown_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_src_collapse_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/collapse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_src_tab_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/tab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__("../../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_production__ = __webpack_require__("./lib/production.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_Search__ = __webpack_require__("./lib/Search/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_serviceStatus__ = __webpack_require__("./lib/serviceStatus.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











Object(__WEBPACK_IMPORTED_MODULE_8__lib_serviceStatus__["a" /* checkServiceStatus */])();

__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(_jsx(__WEBPACK_IMPORTED_MODULE_7__lib_Search__["a" /* default */], {}), document.getElementById('search'));

if (true) {
  Object(__WEBPACK_IMPORTED_MODULE_6__lib_production__["a" /* fillLanguageDropdown */])();
}

/***/ }),

/***/ "./lib/Hit/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return License; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deprecated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Owner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Downloads; });
/* unused harmony export Links */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_esm__ = __webpack_require__("../../node_modules/date-fns/esm/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var License = function License(_ref) {
  var type = _ref.type;
  return type ? _jsx('span', {
    className: 'ais-Hit--license'
  }, void 0, type) : null;
};

var Deprecated = function Deprecated(_ref2) {
  var deprecated = _ref2.deprecated;
  return deprecated ? _jsx('span', {
    className: 'ais-Hit--deprecated',
    title: deprecated
  }, void 0, window.i18n.deprecated) : null;
};

var Owner = function Owner(_ref3) {
  var link = _ref3.link,
      avatar = _ref3.avatar,
      name = _ref3.name;
  return _jsx('a', {
    className: 'ais-Hit--ownerLink',
    href: link
  }, void 0, _jsx('img', {
    width: '20',
    height: '20',
    className: 'ais-Hit--ownerAvatar',
    src: 'https://res.cloudinary.com/hilnmyskv/image/fetch/w_40,h_40,f_auto,q_80,fl_lossy/' + avatar
  }), name);
};

var Downloads = function Downloads(_ref4) {
  var downloads = _ref4.downloads,
      humanDownloads = _ref4.humanDownloads;
  return _jsx('span', {
    className: 'ais-Hit--popular ' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* getDownloadBucket */])(downloads),
    title: window.i18n.downloads_in_last_30_days.replace('{count}', downloads.toLocaleString(window.i18n.active_language))
  }, void 0, humanDownloads);
};

var Links = function Links(_ref5) {
  var name = _ref5.name,
      homepage = _ref5.homepage,
      githubRepo = _ref5.githubRepo,
      className = _ref5.className;
  return _jsx('div', {
    className: className
  }, void 0, _jsx('span', {
    className: 'ais-Hit--link-npm'
  }, void 0, _jsx('a', {
    href: 'https://www.npmjs.com/package/' + name,
    title: window.i18n.npm_page_for.replace('{name}', name)
  }, void 0, window.i18n.npm)), githubRepo ? _jsx('span', {
    className: 'ais-Hit--link-github'
  }, void 0, _jsx('a', {
    title: window.i18n.github_repo_of.replace('{name}', name),
    href: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* encode */])(githubRepo.project) + githubRepo.path
  }, void 0, window.i18n.github)) : null, homepage ? _jsx('span', {
    className: 'ais-Hit--link-homepage'
  }, void 0, _jsx('a', {
    title: 'Homepage of ' + name,
    href: homepage
  }, void 0, window.i18n.homepage)) : null);
};

var Hit = function Hit(_ref6) {
  var hit = _ref6.hit,
      onTagClick = _ref6.onTagClick;
  return _jsx('div', {
    className: 'ais-Hits--item'
  }, void 0, _jsx('a', {
    className: 'ais-Hit--name',
    href: Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* packageLink */])(hit.name)
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["Highlight"], {
    attributeName: 'name',
    hit: hit
  })), _jsx(Downloads, {
    downloads: hit.downloadsLast30Days,
    humanDownloads: hit.humanDownloadsLast30Days
  }), _jsx(License, {
    type: hit.license
  }), _jsx(Deprecated, {
    deprecated: hit.deprecated
  }), _jsx('span', {
    className: 'ais-Hit--version'
  }, void 0, hit.version), _jsx('p', {
    className: 'ais-Hit--description'
  }, void 0, hit.deprecated ? hit.deprecated : _jsx(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* HighlightedMarkdown */], {
    attributeName: 'description',
    hit: hit
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Owner, hit.owner), _jsx('span', {
    className: 'ais-Hit--lastUpdate',
    title: window.i18n.last_updated.replace('{update_date}', new Date(hit.modified).toLocaleDateString(window.i18n.active_language))
  }, void 0, window.i18n.time_ago.replace('{time_distance}', Object(__WEBPACK_IMPORTED_MODULE_1_date_fns_esm__["a" /* formatDistance */])(new Date(hit.modified), new Date()))), Object(__WEBPACK_IMPORTED_MODULE_3__util__["g" /* isEmpty */])(hit.keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, Object(__WEBPACK_IMPORTED_MODULE_3__util__["d" /* formatKeywords */])(hit.keywords, hit._highlightResult.keywords, 4, onTagClick)), _jsx(Links, {
    className: 'ais-Hit--links',
    name: hit.name,
    homepage: hit.homepage,
    githubRepo: hit.githubRepo
  }));
};

/* harmony default export */ __webpack_exports__["e"] = (Hit);

/***/ }),

/***/ "./lib/Search/Results.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch__ = __webpack_require__("../../node_modules/react-instantsearch/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hit__ = __webpack_require__("./lib/Hit/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util__ = __webpack_require__("./lib/util.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var body = document.querySelector('body');

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["CurrentRefinements"], {});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["Pagination"], {
  showFirst: false,
  showLast: false,
  scrollTo: true
});

var ResultsFound = function ResultsFound(_ref) {
  var pagination = _ref.pagination,
      onTagClick = _ref.onTagClick;
  return _jsx('div', {
    className: 'container'
  }, void 0, _jsx('div', {
    className: 'mx-3'
  }, void 0, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["Stats"], {
    translations: {
      stats: function stats(num, time) {
        return window.i18n.result_stats.replace('{number_packages}', num.toLocaleString(window.i18n.active_language)).replace('{time_search}', time);
      }
    }
  })), _jsx(__WEBPACK_IMPORTED_MODULE_3_react_instantsearch_dom__["Hits"], {
    hitComponent: function hitComponent(_ref3) {
      var hit = _ref3.hit;
      return _jsx(__WEBPACK_IMPORTED_MODULE_4__Hit__["e" /* default */], {
        onTagClick: onTagClick,
        hit: hit
      }, hit.objectID);
    }
  }), _jsx('div', {
    className: 'd-flex'
  }, void 0, pagination ? _ref4 : _jsx('div', {
    style: { height: '3rem' }
  })), _jsx('div', {
    className: 'search-footer'
  }, void 0, window.i18n.search_by_algolia, ' - ', _jsx('a', {
    href: 'https://discourse.algolia.com/t/2016-algolia-community-gift-yarn-package-search/319'
  }, void 0, window.i18n.search_by_read_more), '.'));
};

var _ref6 = _jsx('span', {});

var Results = Object(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__["connectStateResults"])(function (_ref5) {
  var searchState = _ref5.searchState,
      searchResults = _ref5.searchResults,
      onTagClick = _ref5.onTagClick;

  if (searchState && Object(__WEBPACK_IMPORTED_MODULE_5__util__["g" /* isEmpty */])(searchState.query) || !searchState) {
    body.classList.remove('searching');
    return _ref6;
  } else if (searchResults && searchResults.nbHits === 0) {
    body.classList.add('searching');
    var docMessage = window.i18n.no_results_docsearch.split(/[{}]+/);
    docMessage[docMessage.indexOf('documentation_link')] = _jsx('a', {
      href: window.i18n.url_base + '/docs'
    }, void 0, window.i18n.documentation);

    return _jsx('div', {
      className: 'container text-center mt-5'
    }, void 0, _jsx('p', {}, void 0, window.i18n.no_package_found.replace('{name}', query)), _jsx('p', {}, void 0, docMessage.map(function (val, index) {
      return _jsx('span', {}, index, val);
    })));
  } else {
    body.classList.add('searching');
    return _jsx(ResultsFound, {
      pagination: searchResults && searchResults.nbPages > 1,
      onTagClick: onTagClick
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Results);

/***/ }),

/***/ "./lib/Search/SearchBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var WrappedSearchBox = function (_Component) {
  _inherits(WrappedSearchBox, _Component);

  function WrappedSearchBox(props) {
    _classCallCheck(this, WrappedSearchBox);

    var _this = _possibleConstructorReturn(this, (WrappedSearchBox.__proto__ || Object.getPrototypeOf(WrappedSearchBox)).call(this, props));

    _this.state = { active: false };
    return _this;
  }

  _createClass(WrappedSearchBox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _jsx('div', {
        className: this.state.active ? 'active' : ''
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["SearchBox"], _extends({
        onFocus: function onFocus() {
          _this2.setState({
            active: true
          });
        },
        onBlur: function onBlur() {
          _this2.setState({
            active: false
          });
        }
      }, this.props)));
    }
  }]);

  return WrappedSearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (WrappedSearchBox);

/***/ }),

/***/ "./lib/Search/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch/dom.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SearchBox__ = __webpack_require__("./lib/Search/SearchBox.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Results__ = __webpack_require__("./lib/Search/Results.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withUrlSync__ = __webpack_require__("./lib/Search/withUrlSync.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__("./lib/config.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var equals = function equals(arr1, arr2) {
  return arr1.length === arr2.length && arr1.reduce(function (a, b, i) {
    return a && arr2[i];
  }, true);
};

// package overview page
// home page (/:lang/)
var shouldFocus = function shouldFocus(path) {
  return path.includes('/packages') || path.replace(/\/[a-zA-Z\-]+\/?/, '').length === 0;
};

var RefinementList = function (_Component) {
  _inherits(RefinementList, _Component);

  function RefinementList() {
    _classCallCheck(this, RefinementList);

    return _possibleConstructorReturn(this, (RefinementList.__proto__ || Object.getPrototypeOf(RefinementList)).apply(this, arguments));
  }

  _createClass(RefinementList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var currentRefinement = newProps.currentRefinement,
          defaultRefinement = newProps.defaultRefinement,
          onRefine = newProps.onRefine,
          refine = newProps.refine;
      var _props = this.props,
          oldCurrentRefinement = _props.currentRefinement,
          oldDefaultRefinement = _props.defaultRefinement;


      if (!equals(currentRefinement, oldCurrentRefinement)) {
        refine(currentRefinement);
        onRefine(currentRefinement);
      }

      if (!equals(defaultRefinement, oldDefaultRefinement)) {
        refine(defaultRefinement);
        onRefine(defaultRefinement);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return RefinementList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var VirtualRefinementList = Object(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_connectors__["connectRefinementList"])(RefinementList);

var Search = function (_Component2) {
  _inherits(Search, _Component2);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this2 = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this2.state = { tags: new Set() };
    _this2.addTag = _this2.addTag.bind(_this2);
    _this2.onRefine = _this2.onRefine.bind(_this2);
    return _this2;
  }

  _createClass(Search, [{
    key: 'addTag',
    value: function addTag(newTag) {
      this.setState(function (_ref) {
        var tags = _ref.tags;
        return { tags: tags.add(newTag) };
      });
    }
  }, {
    key: 'onRefine',
    value: function onRefine(newTags) {
      this.setState(function () {
        return { tags: new Set(newTags) };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          searchState = _props2.searchState,
          onSearchStateChange = _props2.onSearchStateChange;


      return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["InstantSearch"], {
        appId: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* algolia */].appId,
        apiKey: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* algolia */].apiKey,
        indexName: __WEBPACK_IMPORTED_MODULE_6__config__["a" /* algolia */].indexName,
        searchState: searchState,
        onSearchStateChange: onSearchStateChange
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["Configure"], {
        hitsPerPage: 5,
        facets: ['keywords'],
        attributesToRetrieve: ['deprecated', 'description', 'downloadsLast30Days', 'githubRepo', 'homepage', 'humanDownloadsLast30Days', 'keywords', 'license', 'modified', 'name', 'owner', 'version'],
        attributesToHighlight: ['name', 'description', 'keywords']
      }), _jsx(__WEBPACK_IMPORTED_MODULE_3__SearchBox__["a" /* default */], {
        autoFocus: shouldFocus(window.location.pathname),
        translations: {
          placeholder: window.i18n.search_placeholder
        }
      }), _jsx(VirtualRefinementList, {
        attributeName: 'keywords',
        defaultRefinement: [].concat(_toConsumableArray(this.state.tags)),
        onRefine: this.onRefine
      }), _jsx(__WEBPACK_IMPORTED_MODULE_4__Results__["a" /* default */], {
        onTagClick: this.addTag
      }));
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__withUrlSync__["a" /* default */])(Search));

/***/ }),

/***/ "./lib/Search/withUrlSync.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("../../node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var updateAfter = 700;
var searchStateToQueryString = function searchStateToQueryString(searchState) {
  return {
    q: searchState.query,
    p: searchState.page
  };
};

var searchStateToUrl = function searchStateToUrl(searchState) {
  return searchState ? window.i18n.url_base + '/packages?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(searchStateToQueryString(searchState)) : '';
};

var queryStringToSearchState = function queryStringToSearchState(queryString) {
  var _qs$parse = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(queryString),
      p = _qs$parse.p,
      q = _qs$parse.q;

  return {
    query: q,
    page: p || 1
  };
};

var originalPathName = location.pathname;

/* harmony default export */ __webpack_exports__["a"] = (function (App) {
  return function (_Component) {
    _inherits(_class2, _Component);

    function _class2() {
      _classCallCheck(this, _class2);

      var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

      _this.onSearchStateChange = function (searchState) {
        clearTimeout(_this.debouncedSetState);

        if (searchState.query === '') {
          if (location.pathname !== originalPathName) {
            window.history.pushState(null, 'Search packages | Yarn', originalPathName);
          }
        } else {
          _this.debouncedSetState = setTimeout(function () {
            window.history.pushState(searchState, 'Search packages | Yarn', searchStateToUrl(searchState));
          }, updateAfter);
        }

        _this.setState({ searchState: searchState });
      };

      _this.state = {
        searchState: queryStringToSearchState(location.search.slice(1))
      };
      window.addEventListener('popstate', function (_ref) {
        var searchState = _ref.state;

        // check we are on a search result
        if (searchState !== null) {
          _this.setState({ searchState: searchState });
          return;
        }

        _this.setState({ searchState: { query: '', page: 1 } });
      });
      return _this;
    }

    _createClass(_class2, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App, _extends({}, this.props, {
          searchState: this.state.searchState,
          onSearchStateChange: this.onSearchStateChange.bind(this),
          createURL: searchStateToUrl
        }));
      }
    }]);

    return _class2;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
});

/***/ }),

/***/ "./lib/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return algolia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return docsearch; });
var algolia = {
  appId: 'OFCNCOG2CU',
  apiKey: 'f54e21fa3a2a0160595bb058179bfb1e',
  indexName: 'npm-search'
};

var docsearch = {
  apiKey: '3949f721e5d8ca1de8928152ff745b28',
  indexName: 'yarnpkg'
};

/***/ }),

/***/ "./lib/production.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fillLanguageDropdown;
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

function fillLanguageDropdown() {
  // Takes over language dropdown to set cookie
  var langMenu = document.getElementById('dropdownNavLanguageMenu');
  if (langMenu) {
    var langMenuItems = langMenu.querySelectorAll('dropdown-item');

    langMenuItems.forEach(function (langMenuItem) {
      langMenuItem.addEventListener('click', function (event) {
        event.preventDefault();
        var target = event.currentTarget;
        var lang = target.dataset.lang;
        document.cookie = 'nf_lang=' + lang;
        location.reload();
      });
    });
  }
}

/***/ }),

/***/ "./lib/serviceStatus.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkServiceStatus;
/* unused harmony export showStatusMessage */
function checkServiceStatus() {
  var xhr = new XMLHttpRequest();
  xhr.open('get', 'https://status.yarnpkg.com/api/v1/status', true);
  xhr.onload = function () {
    try {
      var data = JSON.parse(xhr.responseText).data;
      if (data.status !== 'success') {
        showStatusMessage(data.message);
      }
    } catch (ex) {
      console.warn('Could not fetch service status: ' + ex.message);
    }
  };
  xhr.send();
}

function showStatusMessage(message) {
  var alertEl = document.createElement('div');
  alertEl.className = 'alert alert-danger alert-dismissible fade hide';
  alertEl.setAttribute('role', 'alert');
  alertEl.innerHTML = '\n    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n      <span aria-hidden="true">&times;</span>\n    </button>\n    <strong>Status:</strong>\n    <span class="system-status"></span>.\n    <a href="https://status.yarnpkg.com/" class="alert-link">Read More &rarr;</a>\n    </div>';

  // Set text using textContent so it's not vulnerable to XSS
  var messageEl = alertEl.querySelector('.system-status');
  messageEl.textContent = message;

  // Insert into the hero, above the title
  var containerEl = document.querySelector('.hero > .container');
  if (!containerEl) {
    containerEl = document.body;
  }
  containerEl.insertBefore(alertEl, containerEl.firstChild);

  // Fade the alert in
  window.setTimeout(function () {
    return alertEl.classList.remove('hide');
  }, 0);
  window.setTimeout(function () {
    return alertEl.classList.add('show');
  }, 20);
}

/***/ }),

/***/ "./lib/util.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatKeywords; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return encode; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDownloadBucket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Keywords; });
/* harmony export (immutable) */ __webpack_exports__["h"] = packageJSONLink;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return packageLink; });
/* unused harmony export searchLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return prefixURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return safeMarkdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html__ = __webpack_require__("../../node_modules/unescape-html/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_unescape_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__ = __webpack_require__("../../node_modules/react-instantsearch/src/core/highlightTags.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__ = __webpack_require__("../../node_modules/react-instantsearch/connectors.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__);


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();









var isEmpty = function isEmpty(item) {
  return typeof item === 'undefined' || item.length < 1;
};

var encode = function encode(val) {
  return encodeURIComponent(val);
};

function getDownloadBucket(dl) {
  if (dl < 1000) {
    return null;
  } else if (dl < 5000) {
    return 'hot-t1';
  } else if (dl < 25000) {
    return 'hot-t2';
  } else if (dl < 1000000) {
    return 'hot-t3';
  } else {
    return 'hot-t4';
  }
}

var Keywords = function Keywords(_ref) {
  var _ref$keywords = _ref.keywords,
      keywords = _ref$keywords === undefined ? [] : _ref$keywords,
      _ref$maxKeywords = _ref.maxKeywords,
      maxKeywords = _ref$maxKeywords === undefined ? 4 : _ref$maxKeywords;

  return isEmpty(keywords) ? null : _jsx('span', {
    className: 'ais-Hit--keywords hidden-sm-down'
  }, void 0, keywords.slice(0, maxKeywords).map(function (keyword) {
    return _jsx('a', {
      href: searchLink(keyword)
    }, name + '-' + keyword, keyword);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  }));
};

function formatKeywords() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var highlightedKeywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maxKeywords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var _onClick = arguments[3];

  if (isEmpty(keywords)) return keywords;
  highlightedKeywords.forEach(function (el, i) {
    el.originalValue = keywords[i];
  });
  return highlightedKeywords.sort(function (k1, k2) {
    // sort keywords by match level
    if (k1.matchLevel !== k2.matchLevel) {
      if (k1.matchLevel === 'full') return -1;
      if (k2.matchLevel === 'full') return 1;
      return k1.matchLevel === 'partial' ? -1 : 1;
    }
    if (k1.matchedWords.length !== k2.matchedWords.length) {
      return k2.matchedWords.length - k1.matchedWords.length;
    }
    if (k1.matchedWords.join('').length !== k2.matchedWords.join('').length) {
      return k2.matchedWords.join('').length - k1.matchedWords.join('').length;
    }
    return 0;
  }).slice(0, maxKeywords).map(function (_ref2, keywordIndex) {
    var highlightedKeyword = _ref2.value,
        keyword = _ref2.originalValue;

    var highlighted = parseHighlightedAttribute({
      highlightedValue: highlightedKeyword
    });
    var content = highlighted.map(function (v, i) {
      var key = 'split-' + i + '-' + v.value;
      if (v.isHighlighted) {
        return _jsx('em', {
          className: 'ais-Highlight__highlighted'
        }, key, v.value);
      }
      return _jsx('span', {
        className: 'ais-Highlight__nonHighlighted'
      }, key, v.value);
    });
    return _jsx('span', {
      className: 'ais-Hit--keyword',
      onClick: function onClick() {
        return _onClick(keyword);
      }
    }, '' + keyword + keywordIndex, content);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  });
}

function parseHighlightedAttribute(_ref3) {
  var _ref3$preTag = _ref3.preTag,
      preTag = _ref3$preTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPreTag : _ref3$preTag,
      _ref3$postTag = _ref3.postTag,
      postTag = _ref3$postTag === undefined ? __WEBPACK_IMPORTED_MODULE_5_react_instantsearch_src_core_highlightTags___default.a.highlightPostTag : _ref3$postTag,
      highlightedValue = _ref3.highlightedValue;

  var splitByPreTag = highlightedValue.split(preTag);
  var firstValue = splitByPreTag.shift();
  var elements = firstValue === '' ? [] : [{ value: firstValue, isHighlighted: false }];

  if (postTag === preTag) {
    var isHighlighted = true;
    splitByPreTag.forEach(function (split) {
      elements.push({ value: split, isHighlighted: isHighlighted });
      isHighlighted = !isHighlighted;
    });
  } else {
    splitByPreTag.forEach(function (split) {
      var splitByPostTag = split.split(postTag);
      elements.push({
        value: splitByPostTag[0],
        isHighlighted: true
      });

      if (splitByPostTag[1] !== '') {
        elements.push({
          value: splitByPostTag[1],
          isHighlighted: false
        });
      }
    });
  }

  return elements;
}

function packageJSONLink(_ref4) {
  var githubRepo = _ref4.githubRepo;

  if (githubRepo) {
    var user = githubRepo.user,
        project = githubRepo.project,
        path = githubRepo.path,
        head = githubRepo.head;


    return {
      packageJSONLink: prefixURL('package.json', {
        base: 'https://github.com',
        user: user,
        project: project,
        head: head ? 'tree/' + head : 'tree/master',
        path: path
      })
    };
  }
  return {};
}

var packageLink = function packageLink(name) {
  return window.i18n.url_base + '/package' + ( true ? '/' : '?') + name;
};

var searchLink = function searchLink(query) {
  return window.i18n.url_base + '/packages?q=' + query;
};

var prefixURL = function prefixURL(url, _ref5) {
  var base = _ref5.base,
      user = _ref5.user,
      project = _ref5.project,
      head = _ref5.head,
      path = _ref5.path;

  if (url.indexOf('//') > 0) {
    return url;
  } else {
    return new URL((path ? path.replace(/^\//, '') + '/' : '') + url.replace(/^(\.?\/?)/, ''), base + '/' + user + '/' + project + '/' + (path ? '' : head + '/'));
  }
};

var status = function status(res) {
  return new Promise(function (resolve, reject) {
    if (res.status >= 200 && res.status < 300) {
      // GitHub will return status 202 or 204 if things like contributor activity are
      // valid, but not yet computed, and will return an empty response
      if (res.status === 202 || res.status === 204) {
        reject(res);
      }
      resolve(res);
    } else {
      reject(res);
    }
  });
};

var get = function get(_ref6) {
  var url = _ref6.url,
      type = _ref6.type;
  return Object(__WEBPACK_IMPORTED_MODULE_1_unfetch__["a" /* default */])(url).then(status).then(function (res) {
    return res[type]();
  }).catch(function (err) {
    // in case it's a useless response by GitHub, tell the caller to retry
    if (err.status === 202 || err.status === 204) {
      throw 'retry';
    } else {
      console.warn(err);
    }
  });
};

var HighlightedMarkdown = Object(__WEBPACK_IMPORTED_MODULE_6_react_instantsearch_connectors__["connectHighlight"])(function (_ref7) {
  var highlight = _ref7.highlight,
      attributeName = _ref7.attributeName,
      hit = _ref7.hit;
  return _jsx('span', {
    className: 'ais-Hit--keyword'
  }, void 0, highlight({
    attributeName: attributeName,
    hit: hit,
    highlightProperty: '_highlightResult'
  }).map(function (v, i) {
    return v.isHighlighted ? _jsx('em', {
      className: 'ais-Highlight__highlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value) : _jsx('span', {
      className: 'ais-Highlight__nonHighlighted',
      dangerouslySetInnerHTML: safeMarkdown(v.value)
    }, 'split-' + i + '-' + v.value);
  }));
});

var inlineRenderer = new __WEBPACK_IMPORTED_MODULE_2_marked___default.a.Renderer();
inlineRenderer.paragraph = function (text) {
  return text;
};

var safeMarkdown = function safeMarkdown(input) {
  return {
    __html: __WEBPACK_IMPORTED_MODULE_3_xss___default()(__WEBPACK_IMPORTED_MODULE_2_marked___default()(__WEBPACK_IMPORTED_MODULE_4_unescape_html___default()(input), { renderer: inlineRenderer }))
  };
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},["./common.js"]);


// WEBPACK FOOTER //
// common.ba2f5b59a52bca95818b.js